/**
 * Routes that render without the tab bar — the immersive screens.
 *
 * They live *inside* `TabLayout`'s route anyway (see `AppRoutes`). Keeping them
 * there is what stops the whole tab subtree from unmounting when the user opens
 * a diagnosis: React then reconciles the shell as the same fiber and only the
 * `<Outlet>` content swaps, so the View Transitions snapshot has a stable tree
 * underneath it. Moving them back out reintroduces the WKWebView flicker.
 *
 * Declared here rather than in `AppRoutes` so the layout can read it without a
 * routes → layouts → routes import cycle.
 */
export const FULLSCREEN_PATHS = [
  '/diagnosis',
  '/history',
  '/result',
  // 프로필은 몰입 화면이라서가 아니라 **드릴다운**이라 여기 있다 — MY 에서 `>`로
  // 들어와 헤더의 뒤로가기로 나간다. 탭바를 깔면 저장 바가 그 위에 겹쳐 서고,
  // 화면 아래 100px 을 나가는 문 두 개가 나눠 갖는다.
  '/more/profile',
  // MY 의 문서 화면도 같은 드릴다운이다 — 헤더의 뒤로가기로 나간다.
  '/more/docs',
  // 언어 선택 — MY 의 `언어` 줄에서 들어오는 드릴다운이고 바닥은 `완료` 버튼이 쓴다.
  '/more/language',
  // 의견 남기기 — 나가는 문은 헤더의 X 하나이고 바닥은 제출 버튼이 쓴다.
  '/more/feedback',
];

/** Whether `pathname` is one of the immersive screens (or a child of one). */
export const isFullscreenPath = (pathname: string): boolean =>
  FULLSCREEN_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
